import React, { useEffect, useState } from 'react';
import "../expertise/expertise.css";
import rightarrow from '../../images/arrow right.svg';
import circleback from '../../images/icons/circleback.webp'
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

import { ReactComponent as reactSVG } from '../../images/icons/react.svg'
import { ReactComponent as JSSVG } from '../../images/icons/js.svg'
import { ReactComponent as NextSVG } from '../../images/icons/nextjs.svg'
import { ReactComponent as TypescriptSVG } from '../../images/icons/typescript.svg'
import { ReactComponent as AngularSVG } from '../../images/icons/angular.svg'
import { ReactComponent as VuejsSVG } from '../../images/icons/vuejs.svg'
import { ReactComponent as WebflowSVG } from '../../images/icons/webflow.svg'

import { ReactComponent as NodejsSVG } from '../../images/icons/nodejs.svg'
import { ReactComponent as PHPSVG } from '../../images/icons/php.svg'
import { ReactComponent as JavaVG } from '../../images/icons/java.svg'
import { ReactComponent as GoSVG } from '../../images/icons/go.svg'
import { ReactComponent as PythonSVG } from '../../images/icons/python.svg'
import { ReactComponent as NetSVG } from '../../images/icons/net.svg'
import { ReactComponent as LaravelSVG } from '../../images/icons/laravel.svg'

import { ReactComponent as TensflowSVG } from '../../images/icons/tensflow.svg'
import { ReactComponent as PytorchSVG } from '../../images/icons/pytorch.svg'
import { ReactComponent as MediapipeSVG } from '../../images/icons/mediapipe.svg'
import { ReactComponent as GooglecolabSVG } from '../../images/icons/googlecolab.svg'
import { ReactComponent as ScikitlearnVG } from '../../images/icons/scikitlearn.svg'
import { ReactComponent as OpencvSVG } from '../../images/icons/opencv.svg'
import { ReactComponent as KerasSVG } from '../../images/icons/keras.svg'


import { ReactComponent as UnitySVG } from '../../images/icons/unity.svg'
import { ReactComponent as ARCoreSVG } from '../../images/icons/arcore.svg'
import { ReactComponent as ARkitSVG } from '../../images/icons/arkit.svg'
import { ReactComponent as ARtoolkitSVG } from '../../images/icons/artoolkit.svg'
import { ReactComponent as VuforiaSVG } from '../../images/icons/vuforia.svg'


import { ReactComponent as AWSSVG } from '../../images/icons/aws.svg'
import { ReactComponent as AzureSVG } from '../../images/icons/azure.svg'
import { ReactComponent as GCPSVG } from '../../images/icons/gcp.svg'
import { ReactComponent as DockerSVG } from '../../images/icons/docker.svg'
import { ReactComponent as KubernetesSVG } from '../../images/icons/kubernetes.svg'
import { ReactComponent as ArgocdSVG } from '../../images/icons/argocd.svg'
import { ReactComponent as TerraformSVG } from '../../images/icons/terraform.svg'


const Expertisedata = [
  {
    id: 0,
    name: "frontend",
    items: [
      {
        id: 0,
        title: "React JS",
        icon: reactSVG,
      },
      {
        id: 1,
        title: "Javascript",
        icon: JSSVG,
      },
      {
        id: 2,
        title: "Next.JS",
        icon: NextSVG,
      },
      {
        id: 3,
        title: "Angular",
        icon: AngularSVG,
      },
      {
        id: 4,
        title: "Vue.JS",
        icon: VuejsSVG,
      },
      {
        id: 5,
        title: "TypeScript",
        icon: TypescriptSVG,
      },
      {
        id: 6,
        title: "Webflow",
        icon: WebflowSVG,
      },
    ],
  },
  {
    id: 1,
    name: "backend",
    items: [
      {
        id: 0,
        title: "Node.JS",
        icon: NodejsSVG,
      },
      {
        id: 1,
        title: "PHP",
        icon: PHPSVG,
      },
      {
        id: 2,
        title: "Java",
        icon: JavaVG,
      },
      {
        id: 3,
        title: "Go",
        icon: GoSVG,
      },
      {
        id: 4,
        title: "Python",
        icon: PythonSVG,
      },
      {
        id: 5,
        title: ".NET",
        icon: NetSVG,
      },
      {
        id: 6,
        title: "Laravel",
        icon: LaravelSVG,
      }
    ],
  },
  {
    id: 2,
    name: "AI&ML",
    items: [
      {
        id: 0,
        title: "TensorFlow",
        icon: TensflowSVG,
      },
      {
        id: 1,
        title: "PyTorch",
        icon: PytorchSVG,
      },
      {
        id: 2,
        title: "MediaPipe",
        icon: MediapipeSVG,
      },
      {
        id: 3,
        title: "Google Colab",
        icon: GooglecolabSVG,
      },
      {
        id: 4,
        title: "Scikit-learn",
        icon: ScikitlearnVG,
      },
      {
        id: 5,
        title: "OpenCV",
        icon: OpencvSVG,
      },
      {
        id: 6,
        title: "Keras",
        icon: KerasSVG,
      }
    ],
  },
  {
    id: 3,
    name: "AR/VR",
    items: [
      {
        id: 0,
        title: "Unity Engine",
        icon: UnitySVG,
      },
      {
        id: 1,
        title: "Vuforia Engine",
        icon: VuforiaSVG,
      },
      {
        id: 2,
        title: "ARCore",
        icon: ARCoreSVG,
      },
      {
        id: 3,
        title: "ARKit",
        icon: ARkitSVG,
      },
      {
        id: 4,
        title: "OpenCV",
        icon: OpencvSVG,
      },
      {
        id: 5,
        title: "MediaPipe",
        icon: MediapipeSVG,
      },
      {
        id: 6,
        title: "AR toolkit",
        icon: ARtoolkitSVG,
      }
    ],
  },
  {
    id: 4,
    name: "Devops",
    items: [
      {
        id: 0,
        title: "AWS",
        icon: AWSSVG,
      },
      {
        id: 1,
        title: "Azure",
        icon: AzureSVG,
      },
      {
        id: 2,
        title: "GCP",
        icon: GCPSVG,
      },
      {
        id: 3,
        title: "Docker",
        icon: DockerSVG,
      },
      {
        id: 4,
        title: "Kubernetes",
        icon: KubernetesSVG,
      },
      {
        id: 5,
        title: "ArgoCD",
        icon: ArgocdSVG,
      },
      {
        id: 6,
        title: "Terraform",
        icon: TerraformSVG,
      }
    ],
  }
];

function Expertise() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  const [selectedCategory, setSelectedCategory] = useState("AR/VR");
  const [isActive, setIsActive] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null); // Track hovered item

  // Filter items based on the selected category
  const currentItems = Expertisedata.find(
    (item) => item.name === selectedCategory
  )?.items || [];

  const handleCategorySwitch = (category) => {
    setIsActive(false); // Reset active state for animation
    setTimeout(() => {
      setSelectedCategory(category);
      setIsActive(true); // Add active class with animation
    }, 100); // Short delay for animation reset
  };


  return (
    <section className='expertise-main'>
      <div className="expertise-inner">
        <div className="expertise-content">
          <div className="items-container" data-aos="zoom-out-up" data-aos-offset="500">
            <div className={`itemsrow ${isActive ? 'itemsrow-active' : ''}`}>
              {
                console.log(isActive)
              }
              {currentItems.map((iteminfo, index) => {

                const ExpLogoComponent = iteminfo.icon;
                return (
                  <div
                    key={iteminfo.id}
                    className="item"
                    onMouseOver={() => setHoveredItem(index)}
                    onMouseOut={() => setHoveredItem(null)} // Reset hover state
                  >
                    <ExpLogoComponent alt={iteminfo.title} />

                    {hoveredItem === index && (
                      <div className="hover-info">
                        {/* Example hover content based on index */}
                        {index > 3 ? <p className='infoitem-right'>{iteminfo.title}</p> : null}
                        {index < 3 ? <p className='infoitem-left'>{iteminfo.title}</p> : null}
                        {index == 3 ? <p className='infoitem-center'>{iteminfo.title}</p> : null}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          <div className="A-title" data-aos="fade-up" data-aos-offset="20">
            <span data-aos="fade-up">Expertise</span>
            <h1 data-aos="fade-up">Mastering Tomorrow’s Technologies, Today!</h1>
            <p data-aos="fade-up" className='title-text'>We excel in advanced technologies, mastering cutting-edge solutions through years of expertise.</p>
            <div className="switch-buttons" data-aos="fade-up" data-aos-offset="20">
              {["AR/VR", "AI&ML", "backend", "Devops", "frontend"].map(category => (
                <button
                  key={category}
                  className={selectedCategory === category ? 'expertiseitem-active' : ''}
                  onClick={() => handleCategorySwitch(category)}
                >
                  {category.toUpperCase()}
                </button>
              ))}
              {/* <div className="expertisetabindcator"></div> */}
            </div>
            <a className='estimationbuttonlink' href="https://arttteo.com/contact">
              <button className="estimation-button">
                <p>Get your estimation</p>
                <div className="arrow-circle">
                  <img src={rightarrow} alt="" />
                </div>
              </button>
            </a>
          </div>
        </div>
        <img className='circlebackground' src={circleback} alt="" />
      </div>
    </section>
  );
}


export default Expertise;
